export function buildSnapshots(tickerSeries) {
  if (!tickerSeries.length) return { snapshots: [], times: [] }

  const allTimes = new Set()
  tickerSeries.forEach(s => s.t.forEach(time => allTimes.add(time)))
  const times = [...allTimes].sort((a, b) => a - b)

  const indexMap = tickerSeries.map(s => {
    const m = new Map()
    s.t.forEach((time, idx) => m.set(time, idx))

    return m
  })

  const snapshots = times.map(time => (
    tickerSeries
      .map((s, si) => {
        const idx = indexMap[si].get(time)
        if (idx === undefined) return null
        const y = s.y[idx]
        const x = s.x[idx]
        if (y === undefined || Number.isNaN(y)) return null

        return { symbol: s.symbol, x: x || 0, y }
      })
      .filter(b => b !== null)
  ))

  return { snapshots, times }
}

export function formatTradingDate(unixSeconds) {
  const d = new Date(unixSeconds * 1000)
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')

  return `${dd}/${mm}/${d.getFullYear()}`
}
